<template>
	<Body class="page-thankyou" />
	<BaseCmsPage v-slot="{page}">
		<ClientOnly>
			<div class="thankyou-page">
				<div class="wrapper">
					<BaseWebshopCheckout v-slot="{user}">
						<BaseWebshopOrder v-slot="{order, shipping, payment, termsPdf, invoicePdf, paymentTransferUrl}">
							<template v-if="order">
								<div class="title-container">
									<div class="page-wrapper tc-page-wrapper">
										<h1><span>{{order.customer.first_name}}</span> <BaseCmsLabel code="thankyou_title" /></h1>
										<div class="thankyou-content" v-if="page?.content" v-html="page.content" />

										<div class="order-info">
											<div class="order-col order-col-total">
												<div class="order-col-title">{{order.total.items}} <BaseCmsLabel code="thank_you_products" /></div>
												<div class="order-col-value"><BaseUtilsFormatCurrency :price="order.total.total" /></div>
											</div>
											<div class="order-col order-col-shipping">
												<div class="order-col-title"><BaseCmsLabel code="thank_you_shipping" /></div>
												<div class="order-col-value">{{ shipping?.title }}</div>
											</div>
											<div class="order-col order-col-payment">
												<div class="order-col-title"><BaseCmsLabel code="thank_you_payment" /></div>
												<div class="order-col-value">{{ payment?.title }}</div>
											</div>
										</div>

										<div class="thankyou-btns">
											<div class="thank-you-invoice" v-if="invoicePdf">
												<a :href="invoicePdf" target="_blank" class="btn btn-download btn-orange btn-invoice"><BaseCmsLabel code="order_download_invoice" /></a>
											</div>

											<a v-if="termsPdf" :href="termsPdf" target="_blank" class="btn btn-download btn-terms">
												<BaseCmsLabel code="thank_you_download_terms_pdf" tag="span" />
											</a>
										</div>
									</div>
								</div>

								<div class="thankyou-page-bill" v-if="order?.cart?.payment_transfer_data && payment.code == 'opca_uplatnica'">
									<div class="page-wrapper ty-bill-page-wrapper">
										<div class="table-payment-transfer">
											<BaseWebshopPaymentTransfer :data="order.cart.payment_transfer_data" />
										</div>
										<a :href="paymentTransferUrl+'&mode=pdf'" target="_blank" class="btn btn-print"><BaseCmsLabel code="print_payment" /></a>
									</div>
								</div>

								<div class="quick-signup" v-if="!user">
									<div class="thankyou-cnt">
										<BaseAuthQuickSignupForm class="form-animated-label" v-slot="{fields, status, loading}">
											<div class="quick-signup-title"><BaseCmsLabel code="thank_you_quick_registration" /></div>
											<div class="quick-signup-desc"><BaseCmsLabel code="thank_you_quick_reg_info" tag="div" /></div>
											<template v-if="!status?.success">
												<div class="quick-signup-fields" v-interpolation>
													<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel, isTouched, value}">
														<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]">
															<BaseFormInput :id="'quicksignup-' + item.name" />
															<BaseCmsLabel tag="label" :for="'quicksignup-' + item.name" :code="'quick_'+item.name" />
															<span class="error" v-show="errorMessage" v-html="errorMessage" />
														</p>
													</BaseFormField>
												</div>
												<button type="submit" class="btn btn-orange noarrow quick-signup-submit" :class="{'loading': loading}" :disabled="loading"><UiLoader v-if="loading" /><BaseCmsLabel code="form_login" /></button>
											</template>

											<div v-if="status?.success && status?.data.label_name" class="global-success"><BaseCmsLabel :code="status.data.label_name" /></div>
										</BaseAuthQuickSignupForm>
									</div>
								</div>
							</template>
		
						</BaseWebshopOrder>
					</BaseWebshopCheckout>
				</div>
			</div>
			<template #fallback>
				<BaseThemeUiLoading />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const {onMediaQuery} = useDom();
	const {matches: mobileBreakpoint} = onMediaQuery({
		query: '(max-width: 980px)',
	});
</script>

<style lang="less" scoped>
	.thankyou-page{
		position: relative; display: block; padding: 50px 0 70px;
		@media (max-width: @t){padding: 30px 0 50px;}
		@media (max-width: @m){padding: 22px 0 32px;}	
	}
	.wrapper{
		padding: 0; width: 760px; margin: 0 auto;
		@media (max-width: @m){width: 100%; padding: 0 16px;}	
	}
	.thankyou-btns{display: flex; flex-wrap: wrap; gap: 12px;}
	.thank-you-invoice{
		@media (max-width: @m){width: 100%;}
	}
	.order-info{
		position: relative; display: flex; flex-flow: column; gap: 40px; margin-top: 10px; margin-bottom: 40px;
		@media (max-width: @m){gap: 24px; margin-bottom: 28px;}	
	}
	.order-col{
		position: relative; display: flex; flex-flow: column; align-items: flex-start; justify-content: center; padding-left: 88px;
		&:before{.pseudo(72px,72px); display: flex; align-items: center; justify-content: center; flex-grow: 0; flex-shrink: 0; background: var(--lightGray); .icon-cart(); font: 26px/1 var(--fonti); color: var(--blue); border-radius: 50%; left: 0;}
		@media (max-width: @m){
			padding-left: 74px; min-height: 60px;
			&:last-child{margin-bottom: 0;}
			&:before{width: 60px; height: 60px;}
		}
	}
	.order-col-shipping:before{.icon-truck();}
	.order-col-payment:before{.icon-payment();}
	.order-col-title{font-weight: 700; font-size: 14px; line-height: 1.4; margin-bottom: 2px;}
	.order-col-value{font-size: 14px; line-height: 1.4;}
	.thankyou-page-bill{
		position: relative; display: block; margin-top: 40px;
		@media (max-width: @m){margin-top: 28px;}
	}
	@media (max-width: @m){
		.table-payment-transfer{overflow-x: auto;}
		.mail-payment-transfer{width: 580px;}
	}
	.btn-print{margin-top: 12px;}
	.quick-signup{position: relative; display: block; margin-top: 40px;}
	.quick-signup-title{display: block; font-size: 26px; margin-bottom: 4px;}
	.quick-signup-desc{display: block; margin-bottom: 16px;}
	:deep(.field-accept_terms){
		label:before{top: -2px;}
		.error{padding-left: 32px;}
	}
</style>